



































import Table from '@/components/Table/Index.vue';
import EvoplaySessionsData from '@/data/EvoplaySessionsData';
import EvoplaySessionsBody from '@/components/Table/EvoplaySessionsBody.vue';
import {
  Component, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import EvoplaySessionsModule from '@/store/modules/EvoplaySessions';
import { IUsername } from '@/interface/SecretPassword';
import { IEvoplaySessions } from '@/interface/EvoplaySessions';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import GeneralModule from '@/store/modules/General';

@Component({
  components: {
    EvoplaySessionsBody,
    Table,
  },
})
export default class Maintenance extends Mixins(
  ToolMixin, ErrorHandleMixin,
) {
  TableHeadEvoplaySessions = EvoplaySessionsData.TableHeadEvoplaySessions;

  EvoplaySessionsInstance = getModule(EvoplaySessionsModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  userData: IEvoplaySessions = {
    user: '',
    username: '',
    token: '',
  };

  searchUsername: IUsername = {
    username : '',
  };

  async findUser(username: string) {
    this.GeneralInstance.toggleLoading(true);
    const { data , status } = await this.EvoplaySessionsInstance.FindSessions(username);
    this.userData = data;
    if (status.code) this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
  }
}
